import Vue from 'vue'
import Router from 'vue-router'
// import VueGtm from 'vue-gtm'

Vue.use(Router)

/* Vue.use(VueGtm, {
  id: 'GTM-D2TQLB5', // Your GTM ID
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  ignoredViews: ['homepage'] // If router, you can exclude some routes name (case insensitive) (optional)
}) */

export default new Router({
  mode: 'hash',
  routes: [
    {
      // Landing Page -- event list
      path: '/',
      name: 'eventList',
      component: () => import('./views/EventList.vue')
    },
    {
      // Event Detail Page
      path: '/event/:id/detail',
      name: 'eventDetail',
      component: () => import( './views/EventDetail.vue')

    },
    {
      // Registration Form Page
      path: '/registration/:id/:step',
      name: 'registrationForm',
      component: () => import('./views/RegistrationForm.vue'),
      beforeRouteUpdate(to, from, next){
        if (Vue.$store.state.events.length === 0) {
          Vue.$store.dispatch('loadInitialState').then(next())
        }
      }
    },
    {
      path: '/payment/:id/event',
      name: 'Receipt',
      component: () => import('./views/RegistrationReceipt.vue')
    }
  ]
})
